export enum AffixEnum {
  Percentage = '%',
  Amount = '$',
}